import { labelSolidComponents } from "@/core/cut/components";
import type { VoxelField } from "./VoxelField";

export interface RemoveFloatingResult {
  applied: boolean;
  removedComponents: number;
  removedVoxels: number;
  reason?: string;
}

/** Remove every solid component that is not face-connected to the mounting plane. */
export function removeFloatingGeometry(field: VoxelField): RemoveFloatingResult {
  const labelling = labelSolidComponents(field);
  if (labelling.sizes.length === 0) {
    return {
      applied: false,
      removedComponents: 0,
      removedVoxels: 0,
      reason: "There is no geometry to clean.",
    };
  }

  if (!labelling.touchesBase.some(Boolean)) {
    return {
      applied: false,
      removedComponents: 0,
      removedVoxels: 0,
      reason: "No geometry is connected to the base, so nothing was removed.",
    };
  }

  const floating = labelling.touchesBase.map((touchesBase) => !touchesBase);
  const removedComponents = floating.filter(Boolean).length;
  if (removedComponents === 0) {
    return {
      applied: false,
      removedComponents: 0,
      removedVoxels: 0,
      reason: "No floating geometry was found.",
    };
  }

  let removedVoxels = 0;
  for (let p = 0; p < labelling.labels.length; p++) {
    const component = labelling.labels[p] as number;
    if (component < 0 || !floating[component]) continue;
    field.data[p] = field.clamp;
    field.dirty[p] = 1;
    removedVoxels++;
  }

  return { applied: true, removedComponents, removedVoxels };
}
